<template></template>
<script>
    export default {
        props: {
            listen: {
                type: String,
                required: true,
            },
            panels: {
                type: String,
                required: true,
            },
        },
        mounted() {
            $(this.listen).on('click', this.handle);
        },
        methods: {
            handle(e) {
                $(this.listen).removeClass('active'); // Remove from all tabs
                $(e.target).addClass('active'); // Add to active tab

                $(this.panels).removeClass('active'); // Remove from all panels
                $('#panel-' + $(e.target).data('panel')).addClass('active'); // Add to active panel
            },
        },
    };
</script>
